export type Expect<a extends true> = a;
